const MODAL_BASE_STYLES = `
  .modal-cyber-scroll::-webkit-scrollbar { width: 4px; }
  .modal-cyber-scroll::-webkit-scrollbar-track { background: rgba(255,255,255,.04); border-radius: 4px; }
  .modal-cyber-scroll::-webkit-scrollbar-thumb { background: rgba(99,102,241,.4); border-radius: 4px; }
  .modal-cyber-scroll::-webkit-scrollbar-thumb:hover { background: rgba(99,102,241,.7); }
`;

function CyberCorners({ color = "rgba(99,102,241," }) {
  const c = (opacity) => `${color}${opacity})`;
  return (
    <>
      <div style={{ position: "absolute", top: 0, left: 0, width: 18, height: 18, borderTop: `1px solid ${c("0.5")}`, borderLeft: `1px solid ${c("0.5")}`, pointerEvents: "none", zIndex: 5 }} />
      <div style={{ position: "absolute", bottom: 0, right: 0, width: 18, height: 18, borderBottom: `1px solid ${c("0.5")}`, borderRight: `1px solid ${c("0.5")}`, pointerEvents: "none", zIndex: 5 }} />
    </>
  );
}

function CloseButton({ onClose }) {
  return (
    <button
      type="button"
      onClick={onClose}
      style={{
        width: 28, height: 28, borderRadius: 6,
        border: "1px solid rgba(255,255,255,.08)",
        background: "rgba(255,255,255,.04)",
        color: "rgba(148,163,184,.7)",
        fontSize: 11, cursor: "pointer",
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0,
        transition: "background .15s, color .15s",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,.1)"; e.currentTarget.style.color = "rgba(226,232,240,.9)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,.04)"; e.currentTarget.style.color = "rgba(148,163,184,.7)"; }}
    >
      ✕
    </button>
  );
}

function FooterCloseButton({ onClose, label = "Fermer" }) {
  return (
    <button
      type="button"
      onClick={onClose}
      style={{
        padding: "9px 22px", borderRadius: 7, cursor: "pointer",
        border: "1px solid rgba(99,102,241,.45)",
        background: "repeating-linear-gradient(45deg,rgba(99,102,241,.04) 0,rgba(99,102,241,.04) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.14)",
        color: "rgba(165,180,252,.95)", fontSize: 11, fontWeight: 800,
        letterSpacing: ".08em", textTransform: "uppercase",
        clipPath: "polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%)",
        boxShadow: "0 0 14px rgba(99,102,241,.12)",
        fontFamily: "ui-monospace,'SF Mono',Menlo,monospace",
        transition: "all .15s",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "repeating-linear-gradient(45deg,rgba(99,102,241,.07) 0,rgba(99,102,241,.07) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.22)"; e.currentTarget.style.boxShadow = "0 0 20px rgba(99,102,241,.2)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "repeating-linear-gradient(45deg,rgba(99,102,241,.04) 0,rgba(99,102,241,.04) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.14)"; e.currentTarget.style.boxShadow = "0 0 14px rgba(99,102,241,.12)"; }}
    >
      {label}
    </button>
  );
}

// ─── Bouton Indices — style option A, cohérent avec le bouton Fermer ─────────
function HintLink({ onHint }) {
  return (
    <button
      type="button"
      onClick={onHint}
      style={{
        display: "inline-flex", alignItems: "center", gap: 8,
        padding: "9px 18px", cursor: "pointer",
        border: "1px solid rgba(251,191,36,.4)",
        background: "rgba(251,191,36,.1)",
        color: "rgba(251,191,36,.95)",
        fontSize: 11, fontWeight: 800,
        letterSpacing: ".1em", textTransform: "uppercase",
        clipPath: "polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%)",
        fontFamily: "ui-monospace,\'SF Mono\',Menlo,monospace",
        transition: "all .15s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(251,191,36,.18)";
        e.currentTarget.style.borderColor = "rgba(251,191,36,.65)";
        e.currentTarget.style.boxShadow = "0 0 16px rgba(251,191,36,.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(251,191,36,.1)";
        e.currentTarget.style.borderColor = "rgba(251,191,36,.4)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <span style={{ fontSize: 15, fontWeight: 900, lineHeight: 1 }}>◈</span>
      Voir les indices
    </button>
  );
}

const PANEL_STYLE = {
  background: "#04050f",
  border: "1px solid rgba(255,255,255,.08)",
  borderRadius: 14,
  boxShadow: "0 0 60px rgba(0,0,0,.8), 0 0 0 1px rgba(99,102,241,.08)",
  position: "relative",
  overflow: "hidden",
  fontFamily: "ui-monospace,'SF Mono',Menlo,monospace",
};

// ═══════════════════════════════════════════════════════════════════════════════
// ModalRegister — scrollable, max-h, pour contenus longs
//
// Props :
//   onHint ?: () => void   — si fournie, affiche "? Indices" en bas à gauche
//                            À passer uniquement sur les modales d'énigmes
// ═══════════════════════════════════════════════════════════════════════════════
export function ModalRegister({ open, title, children, onClose, onHint, containerClassName = "" }) {
  if (!open) return null;

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center px-4 sm:px-6">
      <style>{MODAL_BASE_STYLES}</style>

      <div
        className="absolute inset-0 bg-black/75 backdrop-blur-sm"
        onMouseDown={onClose}
        onTouchStart={onClose}
      />

      <div
        style={{
          ...PANEL_STYLE,
          width: "100%",
          maxWidth: "36rem",
          maxHeight: "90vh",
          zIndex: 50,
          display: "flex",
          flexDirection: "column",
        }}
        className={["relative select-text", containerClassName].join(" ")}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
      >
        <CyberCorners />

        {/* Header */}
        <div style={{ padding: "14px 18px 12px", borderBottom: "1px solid rgba(255,255,255,.05)", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 9, letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(99,102,241,.6)", marginBottom: 5, fontWeight: 700 }}>
              ◈ Projet Origami
            </div>
            <div style={{ fontSize: 17, fontWeight: 900, color: "rgba(241,245,249,.97)", fontFamily: "ui-sans-serif,system-ui", letterSpacing: "-.01em", lineHeight: 1.2 }}>
              {title}
            </div>
          </div>
          <CloseButton onClose={onClose} />
        </div>

        {/* Corps scrollable */}
        <div
          className="modal-cyber-scroll"
          style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "14px 18px", fontSize: 13, color: "rgba(203,213,225,.85)", lineHeight: 1.65 }}
        >
          {children}
        </div>

        {/* Footer : Indices à gauche (si onHint), Fermer à droite */}
        <div style={{
          padding: "10px 18px 14px",
          borderTop: "1px solid rgba(255,255,255,.05)",
          display: "flex",
          alignItems: "center",
          justifyContent: onHint ? "space-between" : "flex-end",
          flexShrink: 0,
        }}>
          {onHint && <HintLink onHint={onHint} />}
          <FooterCloseButton onClose={onClose} />
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// Modal — couvre le parent relative (ex. zone de jeu)
//
// Props :
//   onHint ?: () => void   — si fournie, affiche "? Indices" en bas à gauche
// ═══════════════════════════════════════════════════════════════════════════════
export function Modal({ open, title, children, onClose, onHint, containerClassName = "" }) {
  if (!open) return null;

  return (
    <div className={["absolute inset-0 z-40 flex items-center justify-center", containerClassName].join(" ")}>
      <style>{MODAL_BASE_STYLES}</style>

      <div
        className="absolute inset-0 bg-black/75 backdrop-blur-sm"
        onMouseDown={onClose}
        onTouchStart={onClose}
      />

      <div
        style={{ ...PANEL_STYLE, width: "100%", maxWidth: "36rem", zIndex: 50 }}
        className="relative select-text"
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
      >
        <CyberCorners />

        {/* Header */}
        <div style={{ padding: "14px 18px 12px", borderBottom: "1px solid rgba(255,255,255,.05)", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
          <div>
            <div style={{ fontSize: 9, letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(99,102,241,.6)", marginBottom: 5, fontWeight: 700 }}>
              ◈ Projet Origami
            </div>
            <div style={{ fontSize: 17, fontWeight: 900, color: "rgba(241,245,249,.97)", fontFamily: "ui-sans-serif,system-ui", letterSpacing: "-.01em", lineHeight: 1.2 }}>
              {title}
            </div>
          </div>
          <CloseButton onClose={onClose} />
        </div>

        {/* Corps */}
        <div style={{ padding: "14px 18px", fontSize: 13, color: "rgba(203,213,225,.85)", lineHeight: 1.65 }}>
          {children}
        </div>

        {/* Footer : Indices à gauche (si onHint), Fermer à droite */}
        <div style={{
          padding: "0 18px 14px",
          display: "flex",
          alignItems: "center",
          justifyContent: onHint ? "space-between" : "flex-end",
        }}>
          {onHint && <HintLink onHint={onHint} />}
          <FooterCloseButton onClose={onClose} />
        </div>
      </div>
    </div>
  );
}